module.exports = __webpack_public_path__ + "img/download.b79792d1.svg";